import * as React from 'react'
import moment from 'moment'
import { ActionsCell } from '../LiveEvents/UpcomingEvents/ActionsCell'

const headerMap = {
  type: 'Type',
  meeting_time: 'Date',
}

export const columns = [
  {
    accessorKey: 'type',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => props.row.original.title,
    enableSorting: false,
  },
  {
    accessorKey: 'meeting_time',
    header: (props) => <TableHeader {...props} />,
    cell: (props) => moment(props.row.original.meeting_time).format('L'),
    sortUndefined: 'last',
    sortDescFirst: true,
  },
  {
    accessorKey: 'Actions',
    header: (props) => <EmptyTableHeader {...props} />,
    cell: (props) => <ActionsCell {...props} />,
    enableSorting: false,
  },
]

function TableHeader({ column }) {
  return <div className="font-roboto">{headerMap[column.id]}</div>
}

function EmptyTableHeader() {
  return <div className="font-roboto"></div>
}
